import { CSSObject } from '@chakra-ui/react';

export const FlexWrapper: CSSObject = {
  bgGradient: 'linear(180deg, alpha.500, alpha.600)',
  boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
  mb: '2',
  borderBottom: '0.5',
  borderBottomColor: 'beta.500',
};

export const FlexBannerWrapper: CSSObject = {
  px: '4',
  pt: '2.5',
  pb: '2',
  m: 'auto',
  h: '48px',
  w: 'container.xl',
};

export const FlexItemsWrapper: CSSObject = {
  mr: '0',
  columnGap: '1',
  '& > div:last-of-type': { mr: '0' },
  minH: '32px',
  pt: '1px',
};

export const LinkItem: CSSObject = {
  w: '152px',
  h: '28px',
  py: '2px',
  borderRadius: 'md',
  bg: 'alpha.500',
  boxShadow: '0px 0px 0px 1px rgba(0, 0, 0, 0.30) inset',
  color: 'white',
  borderColor: 'beta.400',
  borderWidth: '2px',
  textOverflow: 'ellipsis',

  _hover: {
    bg: 'alpha.800',
  },

  '.chakra-badge.state-inprogress': {
    bg: 'gamma.600',
    color: 'beta.800',
    mr: '1',
    mt: '1',
    height: '4',
    borderRadius: 'base',
    maxW: '9',
  },

  '.chakra-badge.state-prior': {
    bg: 'alpha.200',
    color: 'blackAlpha.700',
    mr: '1',
    mt: '1',
    height: '4',
    borderRadius: 'base',
    maxW: '9',
  },

  '.chakra-badge.state-ended': {
    bg: 'gamma.500',
    color: 'gamma.800',
    mr: '1',
    mt: '1',
    height: '4',
    borderRadius: 'base',
    maxW: '9',
  },
};

export const RaceNumber: CSSObject = {
  color: 'white',
};
export const FlexDetails: CSSObject = {
  color: 'white',
  display: 'block',
  maxW: '63px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const Icon: CSSObject = {
  color: 'white',
};

export const FlexButtonContainer: CSSObject = {
  bg: 'transparent',
  pos: 'relative',
  p: '0',
  pl: '1',
  gap: '1',
  mt: '1px',
};

export const ButtonChevron: CSSObject = {
  minW: '6',
  w: '28px',
  h: '28px',
  color: 'white',
  p: '0',
  borderRadius: 'md',
  bg: 'alpha.500',
  borderColor: 'beta.500',
  borderStyle: 'solid',
  borderWidth: '2px',

  _hover: {
    bg: 'alpha.800',
  },

  '& > svg': { boxSize: '6' },
};
